import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button, Icon, Popup, Menu } from "semantic-ui-react";

/**
 * ManuscriptBlockMenu : Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Option menu (and its trigger) for a manuscript block,
 * containg options for moving and removal
 */
class ManuscriptBlockMenu extends Component {
  static propTypes = {
    onDelete: PropTypes.func.isRequired,
    onMove: PropTypes.func.isRequired,

    canMoveUp: PropTypes.bool.isRequired,
    canMoveDown: PropTypes.bool.isRequired
  };

  state = {
    /**
     * isOpen: Boolean
     * True if the option menu is currently open
     */
    isOpen: false
  };

  /**
   * handlePopupVisibilityChange = open => ()
   * Sets whether the popup menu is currently open
   * and reflects any change in state
   */
  handlePopupVisibilityChange = open => {
    this.setState({
      isOpen: open
    });
  };

  /**
   * triggerMove = moveBy => ()
   * Triggers a move of the current block by the specified
   * offset and closes the menu
   */
  triggerMove = moveBy => {
    this.props.onMove(moveBy);
    this.setState({
      isOpen: false
    });
  };

  /**
   * render = () => ()
   * Renders the action trigger and its associated popup
   */
  render() {
    return (
      <Popup
        style={{ boxShadow: "none", padding: "0", border: "none" }}
        basic
        trigger={
          <Button floated="right" basic icon>
            <Icon name="ellipsis vertical" />
          </Button>
        }
        content={
          <Menu vertical fluid className="ed-action-menu">
            {/**
             * Action to delete the current block
             */}
            <Menu.Item name="delete" onClick={this.props.onDelete}>
              <Icon name="trash alternate" />
              <span>
                <FormattedMessage
                  id="manuscript.menu.delete"
                  description="Action text to delete a content block"
                />
              </span>
            </Menu.Item>
            {/**
             * Conditionally renders the action to move the block up
             * by one, if it is not already the first element
             */}
            {this.props.canMoveUp ? (
              <Menu.Item name="move-up" onClick={() => this.triggerMove(-1)}>
                <Icon name="arrow up" />
                <span>
                  <FormattedMessage
                    id="manuscript.menu.moveUp"
                    description="Action text to move up a content block"
                  />
                </span>
              </Menu.Item>
            ) : null}
            {/**
             * Conditionally renders the action to move the block down
             * by one, if it is not already the last element
             */}
            {this.props.canMoveDown ? (
              <Menu.Item name="move-down" onClick={() => this.triggerMove(1)}>
                <Icon name="arrow down" />
                <span>
                  <FormattedMessage
                    id="manuscript.menu.moveDown"
                    description="Action text to move down a content block"
                  />
                </span>
              </Menu.Item>
            ) : null}
          </Menu>
        }
        on="click"
        position="bottom right"
        open={this.state.isOpen}
        onOpen={() => this.handlePopupVisibilityChange(true)}
        onClose={() => this.handlePopupVisibilityChange(false)}
      />
    );
  }
}

export default ManuscriptBlockMenu;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/ManuscriptBlockMenu.js